module.exports = __webpack_public_path__ + "static/media/OlatomiwaLasebikan.8048b253.jpg";